<div
  class="stepper-lateral__summary"
  [class.stepper-lateral__summary--expanded]="isExpanded"
>
  <button
    type="button"
    class="stepper-lateral__summary-header"
    [attr.aria-expanded]="isExpanded"
    (click)="toggle()"
  >
    <span class="stepper-lateral__summary-info">
      <span class="stepper-lateral__summary-title">{{ summary }}</span>
      <svg
        class="stepper-lateral__chevron"
        [class.stepper-lateral__chevron--expanded]="isExpanded"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <path d="M12 15.4 6.6 10l1.4-1.4 4 4 4-4 1.4 1.4z" fill="currentColor" />
      </svg>
    </span>
    <span class="stepper-lateral__progress">
      <span
        *ngFor="let step of steps; let i = index"
        class="stepper-lateral__segment"
        [class.stepper-lateral__segment--complete]="i < currentStep"
        [class.stepper-lateral__segment--current]="i === currentStep"
      ></span>
    </span>
  </button>

  <div
    class="stepper-lateral__panel"
    [class.stepper-lateral__panel--expanded]="isExpanded"
  >
    <div class="stepper-lateral__panel-content">
      <ng-container *ngTemplateOutlet="stepList"></ng-container>
    </div>
  </div>
</div>

<div
  class="stepper-lateral__backdrop"
  [class.stepper-lateral__backdrop--visible]="isExpanded"
  aria-hidden="true"
></div>

<div class="stepper-lateral__desktop">
  <ng-container *ngTemplateOutlet="stepList"></ng-container>
</div>

<ng-template #stepList>
  <ds-stepper orientation="vertical" [steps]="dsSteps"></ds-stepper>
</ng-template>
